function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.29 72.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.44,2.24c-3.08,4.7-7.87,25.33-9.12,39.26-.39,4.35-1.34,8.88-2.11,10.07-.77,1.18-1.66,5.33-1.99,9.21-.47,5.62-.25,7.58,1.07,9.6,1.6,2.45,2.04,2.54,11.99,2.54,13.23,0,13.98-.63,14-11.77.01-5.83-.51-8.85-2.12-12.29-2.55-5.46-3.8-12.81-5.27-31.04-.6-7.49-1.35-14.57-1.66-15.75-.73-2.81-2.9-2.72-4.81.19",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.28,11.16c2.03,25.25,2.54,30.41,3.16,32,.6,1.52.05,1.75-4.17,1.76-2.67,0-5.99.6-7.38,1.32l-2.52,1.31.69-8.66C8.05,26.64,13.84,2.91,15.85,2.91c.42,0,1.07,3.71,1.43,8.25",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.63,47.96c1.66.58,3.52,2.17,4.15,3.55,1.32,2.89,1.51,15.27.26,17.24-.58.91-3.92,1.46-10.51,1.75l-9.67.41-1.01-2.66c-1.1-2.88-.45-10.11,1.31-14.71.72-1.87,2.52-3.52,5.18-4.73,4.74-2.15,6.19-2.27,10.29-.84",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.541a8a25d939f7c86cf2b95d2683d667.svg";
export { ForwardRef as ReactComponent };